import Rollbar from './index';

const isIgnored = (url, ignoredUrls = []) =>
  ignoredUrls.some((ignoredUrl) => {
    if (ignoredUrl instanceof RegExp) return ignoredUrl.test(url);
    return url.includes(ignoredUrl);
  });

const requestError = ({ ignoredUrls, level = 'error' } = {}) => (error) => {
  const { method, url } = error.config || {};
  if (isIgnored(url, ignoredUrls)) return Promise.reject(error);

  const details = { config: error.config, request: error.request };
  Rollbar[level](`API request failed on ${method} ${url}`, details);

  return Promise.reject(error);
};

const responseError = ({ ignoredUrls, level = 'error' } = {}) => (error) => {
  const { status } = error.response || {};
  const { method, url } = error.config || {};
  if (isIgnored(url, ignoredUrls)) return Promise.reject(error);

  const details = { config: error.config, response: error.response };
  Rollbar[level](`API response: error ${status} on ${method} ${url}`, details);
  return Promise.reject(error);
};

const install = (instance, config = {}) => {
  instance.interceptors.request.use(null, requestError(config));
  instance.interceptors.response.use(null, responseError(config));
};

export default {
  requestError,
  responseError,
  install,
};
